var exports = {
  "tB": "ContextMenu.module__backdrop___SC1OQU",
  "D8": "ContextMenu.module__contextMenuPositioner___SC1OQU",
  "He": "ContextMenu.module__contextMenu___SC1OQU",
  "KY": "ContextMenu.module__menuScroller___SC1OQU",
  "NC": "ContextMenu.module__menuScrollerContent___SC1OQU",
  "AS": "ContextMenu.module__item___SC1OQU",
  "r9": "ContextMenu.module__disabled___SC1OQU",
  "OR": "ContextMenu.module__danger___SC1OQU",
  "Fx": "ContextMenu.module__itemIcon___SC1OQU",
  "IR": "ContextMenu.module__itemLabel___SC1OQU",
  "Ah": "ContextMenu.module__itemWithShortcut___SC1OQU",
  "g$": "ContextMenu.module__itemShortcut___SC1OQU",
  "ED": "ContextMenu.module__itemShortcutHidden___SC1OQU",
  "dP": "ContextMenu.module__itemLabelContainer___SC1OQU",
  "b": "ContextMenu.module__itemLabelText___SC1OQU",
  "Lo": "ContextMenu.module__itemHint___SC1OQU",
  "fV": "ContextMenu.module__submenuCaret___SC1OQU",
  "me": "ContextMenu.module__separator___SC1OQU",
  "Os": "ContextMenu.module__group___SC1OQU",
  "_0": "ContextMenu.module__selectableSection___SC1OQU",
  "dl": "ContextMenu.module__checkboxItem___SC1OQU",
  "fb": "ContextMenu.module__checkboxIndicator___SC1OQU",
  "kv": "ContextMenu.module__checkbox___SC1OQU",
  "xY": "ContextMenu.module__checkboxChecked___SC1OQU",
  "AM": "ContextMenu.module__groupLabel___SC1OQU",
  "HG": "ContextMenu.module__submenuPopover___SC1OQU",
  "a": "ContextMenu.module__submenuScroller___SC1OQU",
  "pT": "ContextMenu.module__quickReactionsGroup___SC1OQU",
  "gV": "ContextMenu.module__quickReactionItem___SC1OQU",
  "z5": "ContextMenu.module__quickReactionShortcut___SC1OQU",
  "dd": "ContextMenu.module__quickReactionTooltipContent___SC1OQU",
  "Vx": "ContextMenu.module__quickReactionTooltipHint___SC1OQU",
  "hH": "ContextMenu.module__emojiSubmenuIcon___SC1OQU",
  "XN": "ContextMenu.module__emojiSubmenuImg___SC1OQU",
};

module.exports = exports;
